import * as React from 'react';

import { cn } from '@repo/ui/lib/utils';

interface PageHeaderProps {
  title: string;
  /** One-line purpose description shown under the title. */
  description?: string;
  /** Slot for the primary action button. */
  action?: React.ReactNode;
  className?: string;
}

/**
 * Standard top-of-screen header — title, one-line purpose, and an optional
 * primary action — used by Overview, Mandate, Activity, and Reports so
 * every screen's top is visually consistent.
 */
function PageHeader({ title, description, action, className }: PageHeaderProps) {
  return (
    <div
      data-slot="page-header"
      className={cn('flex flex-wrap items-start justify-between gap-4', className)}
    >
      <div>
        <h1 className="text-rowa-heading text-rowa-text-primary">{title}</h1>
        {description && (
          <p className="text-rowa-body-md text-rowa-text-secondary mt-1">{description}</p>
        )}
      </div>
      {action && (
        <div data-slot="page-header-action" className="max-w-full min-w-0 shrink-0">
          {action}
        </div>
      )}
    </div>
  );
}

export { PageHeader };
export type { PageHeaderProps };
